import React, { useState } from 'react'
import { DeleteVendorProp } from '../types/vendor.type'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import notistack from 'pages/Core/Notistack';
import { deleteVendor } from '../services/vendor.service';
import { HttpStatus } from 'pages/Core';

const DeleteVendor: React.FC<DeleteVendorProp> = ({ isDeleteVendorOpen, selectedId, reloadDataSource, onClose, vendorName = '' }) => {

    const [loading, setLoading] = useState(false);
    const handleDelete = async () => {
        try {
            setLoading(true);
            const response = await deleteVendor(selectedId);
            if (response.status === HttpStatus.Success) {
                notistack.notifyFromApi(response)
                reloadDataSource();
                onClose();
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.error(error || "Error occurred while deleting vendor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                show={isDeleteVendorOpen}
                onHide={() => {
                    onClose();
                }
                }
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-break">
                    Are you sure you want to delete&nbsp;
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="customer-name-tooltip">
                            </Tooltip>
                        }
                    >
                        <strong
                            className="d-inline-block text-truncate"
                            style={{ maxWidth: "250px", verticalAlign: "bottom" }}
                        >
                        </strong>
                    </OverlayTrigger>
                    &nbsp;{vendorName}?
                </Modal.Body>


                <Modal.Footer>
                    <Button
                        variant="btn add-btn"
                        onClick={() => onClose()}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="btn submit-btn"
                        disabled={loading}
                        onClick={handleDelete}
                    >
                        {false ? "Deleting..." : "Delete"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DeleteVendor
